import { Outlet } from 'react-router-dom';

const Layout = () => (
  <div className="min-h-full w-full bg-lightBlue-5 py-4">
    <div className="flex justify-center w-full my-8 bg-white rounded-lg shadow-md max-w-5xl mx-auto">
      <Outlet />
    </div>
  </div>
);

export default Layout;
